import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { LoadingOverlay } from "@shared/schemas/loading-overlay";

interface SingleLoadingOverlay {
	key: string;
	title?: string;
	subtitle?: string;
}

@Injectable({
	providedIn: "root"
})
export class LoadingOverlayService {
	private loadingOverlay = new Subject<LoadingOverlay | null>();
	loadingOverlay$ = this.loadingOverlay.asObservable();

	showLoadingOverlay({ key, title, subtitle }: SingleLoadingOverlay): void {
		const loadingOverlay: LoadingOverlay = {
			key,
			show: true,
			title,
			subtitle
		};
		this.loadingOverlay.next(loadingOverlay);
	}

	closeLoadingOverlay(key: string): void {
		this.loadingOverlay.next({ key: key, show: false });
	}
}
